import utils from '../../../Shared/utils.jsx';

import Form2TextEditor from './texteditor.jsx';
import Form2LookupList from './lookupList.jsx';
import Form2AnyOf from './anyof.jsx';
import Form2Select from './select.jsx';
import Form2Input from './input.jsx';
import Form2Number from './number.jsx';
import Form2Boolean from './boolean.jsx';

/**
 * PropertyGrid2 tag resolution for types that do not import PropertyGrid2 / elementTypes (avoids circular deps with form2/array).
 */
export function getPropertyGrid2LeafElementType(element) {
    if ('format' in element) {
        switch (element.format) {
            case 'TextEditor':
                return Form2TextEditor;
            case 'LookupList':
                return Form2LookupList;
            default:
                break;
        }
    }

    switch (element.type) {
        case 'string':
            if ('anyOf' in element) return Form2AnyOf;
            if (
                ('enum' in element && element.enum !== null) ||
                ('titleMap' in element && element.titleMap !== null)
            )
                return Form2Select;
            return Form2Input;
        case 'integer':
        case 'number':
            return Form2Number;
        case 'boolean':
            return Form2Boolean;
        case 'object':
            return null;
        default: {
            const type =
                'anyOf' in element
                    ? 'anyOf'
                    : 'allOf' in element
                      ? 'allOf'
                      : 'oneOf' in element
                        ? 'oneOf'
                        : 'unknown:' + element.type;
            utils.log('PropertyGrid2 skipping type: ' + type);
            return null;
        }
    }
}
